"use strict";

angular.module('bbwDateSelect', [])

    .directive('bbwDateSelect', [function() {

        var template = [
            '<div class="bbw-date-select">',
            '<select ng-change="onChange(\'date\')" valdr-no-validate class="bbw-date-select-day bbw-date-select-select" ng-class="selectClass" ng-model="val.date" ng-options="d for d in dates">',
            '<option value disabled selected></option>',
            '</select>',
            '<select ng-change="onChange(\'month\')" valdr-no-validate class="bbw-date-select-month bbw-date-select-select" ng-class="selectClass" ng-model="val.month" ng-options="m.value as m.name for m in months">',
            '<option value disabled></option>',
            '</select>',
            '<select ng-change="onChange(\'year\')" valdr-no-validate class="bbw-date-select-year bbw-date-select-select" ng-class="selectClass" ng-model="val.year" ng-options="y for y in years">',
            '<option value disabled selected></option>',
            '</select>',
            '</div>'
        ];

        function constructMoment(spec, defaultValue) {
            if (spec) {
                if (angular.isString(spec) && ['+', '-'].indexOf(spec.charAt(0)) >= 0) { // relative
                    var tokens = spec.substr(1).split(/ +/);
                    switch (spec.charAt(0)) {
                        case '+':
                            return moment().add(tokens[0], tokens[1]);
                        case '-':
                            return moment().subtract(tokens[0], tokens[1]);
                    }
                } else {
                    return moment(spec);
                }
            } else {
                if (angular.isFunction(defaultValue)) {
                    return defaultValue();
                } else if (defaultValue) {
                    return moment(defaultValue);
                } else {
                    return moment();
                }
            }
        }

        function getAgeMin() {
            return moment().subtract(bbw.configuration.age.max, 'years');
        }

        function getAgeMax() {
            return moment().subtract(bbw.configuration.age.min, 'years');
        }

        return {
            restrict: 'A',
            replace: true,
            template: template.join(''),
            require: 'ngModel',
            transclude: true,
            scope: {
                selectClass: '@bbwSelectClass'
            },

            link: function(scope, elem, attrs, model) {
                scope.val = {};

                var min = constructMoment(attrs.min, 'age' in attrs && getAgeMin);
                var max = constructMoment(attrs.max, 'age' in attrs && getAgeMax);

                scope.min = min;
                scope.max = max;

                scope.years = [];

                for (var i = min.year(); i <= max.year(); ++i) {
                    scope.years.push(i);
                }
                if ('age' in attrs) {
                    scope.years.reverse();
                }
                scope.$watch('val.year', function() {
                    updateMonthOptions();
                });

                var isPristine = {
                    date: true,
                    month: true,
                    year:true
                };
                var isTouched = false;

                scope.onChange = function(key) {
                    if (isTouched) {
                        return;
                    }
                    delete isPristine[key];
                    if (Object.keys(isPristine).length == 0) {
                        model.$setDirty();
                        model.$setTouched();
                        isTouched = true;
                    }
                };

                scope.$watchCollection('[val.month, val.year]', function() {
                    updateDateOptions();
                });

                scope.$watchCollection('[val.date, val.month, val.year]', function() {
                    if (scope.val.year && scope.val.month && scope.val.date) {
                        var m = moment([scope.val.year, scope.val.month - 1, scope.val.date]);
                        if ('unixtime' in attrs) {
                            model.$setViewValue(m.unix());
                        } else {
                            model.$setViewValue(m.format('YYYY-MM-DD'));
                        }
                    }
                    else {
                        model.$setViewValue();
                    }
                });

                function updateMonthOptions() {
                    // Values begin at 1 to permit easier boolean testing
                    scope.months = [];

                    var minMonth = 0;
                    var maxMonth = 11;

                    var monthNames = moment.months();

                    for (var j = minMonth; j <= maxMonth; j++) {
                        scope.months.push({
                            name: ngtk.tools.string.ucfirst(monthNames[j]),
                            value: j + 1
                        });
                    }

                    if (scope.val.month - 1 > maxMonth || scope.val.month - 1 < minMonth) delete scope.val.month;
                }

                function updateDateOptions() {
                    scope.dates = [];

                    for (var i = 1; i <= 31; i++) {
                        scope.dates.push(i);
                    }
                }

                // model -> view
                model.$render = function() {
                    if (!model.$viewValue) return;

                    if ('unixtime' in attrs) {
                        var m = moment.unix(model.$viewValue);
                    } else {
                        m = moment(model.$viewValue);
                    }

                    // Always use a dot in ng-model attrs...
                    scope.val = {
                        year: m.year(),
                        month: m.month() + 1,
                        date: m.date()
                    };
                };
            }
        };
    }]);

